import type { JSX } from 'react';
import { KeyRound } from 'lucide-react';

/**
 * Shown while the backend answers 503 VAULT_NOT_CONFIGURED: the encryption
 * key for stored passwords hasn't been added yet.
 */
export function VaultNotConfigured(): JSX.Element {
  return (
    <div className="panel flex flex-col items-center gap-2 rounded-xl px-6 py-10 text-center" role="status">
      <KeyRound className="h-6 w-6 text-muted-foreground/70" aria-hidden />
      <p className="font-medium">Outreach accounts aren&apos;t set up yet.</p>
      <p className="max-w-[60ch] text-sm text-muted-foreground">
        Passwords are stored encrypted, and the encryption key hasn&apos;t been added. An admin with Railway access
        needs to add the <code className="font-mono text-xs">OUTREACH_ACCOUNTS_KEY</code> variable to the outreach
        backend service (generate one with <code className="font-mono text-xs">openssl rand -base64 32</code>) and
        redeploy. Nothing else is needed.
      </p>
    </div>
  );
}
